import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { doc, onSnapshot } from 'firebase/firestore';
import { db } from '../firebaseConfig';
import './ServiceDetailPage.css';
import { useTranslation } from 'react-i18next';

const ServiceDetailPage = () => {
  const { serviceId } = useParams();
  const { i18n } = useTranslation();
  const [serviceData, setServiceData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { t } = useTranslation();

  useEffect(() => {
    setLoading(true);
    setError(null);
    if (!serviceId) { setError("ID servizio mancante."); setLoading(false); return; }
    const docRef = doc(db, 'services', serviceId);
    const unsubscribe = onSnapshot(docRef, (docSnap) => {
      if (docSnap.exists()) {
        const data = docSnap.data();
        setServiceData({ id: docSnap.id, ...data });
        const lang = i18n.language;
        const fallbackLang = 'it';
      } else {
        setError("Servizio non trovato.");
      }
      setLoading(false);
    }, (err) => {
      setError("Errore nel caricamento dei dati.");
      setLoading(false);
    });
    return () => unsubscribe();
  }, [serviceId, i18n.language]);

  const renderContent = () => {
    if (loading) return null;
    if (error) return <div className="container form-status error">{error}</div>;
    if (!serviceData) return <div className="container no-content-text">Dati non disponibili.</div>;

    const lang = i18n.language;
    const fallbackLang = 'it';
    const title = serviceData.title?.[lang] || serviceData.title?.[fallbackLang] || 'Dettaglio Servizio';
    const description = serviceData.description?.[lang] || serviceData.description?.[fallbackLang] || 'Dettagli sul servizio';

    return (
      <div className="service-detail-page">
        <section className="page-header service-detail-header">
            <div className="container"><h1>{title}</h1></div>
        </section>
        <section className="content-section" style={{ paddingLeft: '5vw', paddingRight: '5vw' }}>
              <div className="main-detail-image-container">
                  <img src={serviceData.imageUrl || '/placeholder-image.jpg'} alt={`Immagine ${title}`} />
                   <div className="image-overlay-description">
                      <p>{description}</p>
                  </div>
              </div>
              <div className="dynamic-content-area">
                  {(serviceData.detailContent || []).map((block, index) => {
                      const blockSize = block.size || (block.type === 'text' ? 'normal' : 'full');
                      const blockClass = `content-block ${block.type}-block size-${blockSize}`;
                      const key = block.blockId || index;

                      if (block.type === 'text') {
                          const text = block.value?.[lang] || block.value?.[fallbackLang] || "";
                          return (
                              <div key={key} className={blockClass}>
                                  {text.split('\n').map((line, i) => <p key={i}>{line || <> </>}</p>)}
                              </div>
                          );
                      }
                      if (block.type === 'image') {
                           return (
                              <div key={key} className={blockClass}>
                                  <img src={block.value || '/placeholder-image.jpg'} alt={`Dettaglio ${index + 1}`} onError={(e) => { e.target.onerror = null; e.target.src='/placeholder-image.jpg'}}/>
                              </div>
                          );
                      }
                      return null;
                  })}
                  {(!serviceData.detailContent || serviceData.detailContent.length === 0) && (
                       <p className="no-content-text">(Nessun dettaglio aggiuntivo inserito per questo servizio)</p>
                  )}
              </div>
          </section>
        
        <section className="content-section" style={{ paddingTop: 0 }}>
          <div className="container">
            <div className="contact-button-container">
                <Link to="/contatti" className="cta-button" state={{ requestedService: title }}>{t('buttonRequestInfo')}</Link>
            </div>
          </div>
        </section>
      </div>
    );
  };

  return renderContent();
};

export default ServiceDetailPage;


